/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Estimates Hooks
 *
 * Barrel export for all estimate-related hooks
 *
 * PERFORMANCE: Explicit exports instead of export * for better tree-shaking
 */

// Available Estimates
export type { AvailableEstimate } from "./use-available-estimates";
export { useAvailableEstimates } from "./use-available-estimates";

// Estimate Budget Rates
export { useEstimateBudgetRates } from "./use-estimate-budget-rates";

// Estimate Details
export { useEstimateDetails } from "./use-estimate-details";

// Estimate Line Items
export type {
  EstimateLineItem,
  CreateLineItemData,
  UpdateLineItemData,
} from "./use-estimate-line-items";
export { useEstimateLineItems } from "./use-estimate-line-items";

// Estimate Notes
export type { UseEstimateNotesParams } from "./use-estimate-notes";
export { useEstimateNotes } from "./use-estimate-notes";

// Estimate Phases
export { useEstimatePhases } from "./use-estimate-phases";

// Estimate Revisions
export type {
  EstimateRevision,
  EstimateRevisionsResponse,
  CreateRevisionParams,
} from "./use-estimate-revisions";
export {
  useEstimateRevisions,
  useCreateEstimateRevision,
} from "./use-estimate-revisions";

// Estimate to Tasks Conversion
export type {
  ConvertEstimateToTasksParams,
  ConvertEstimateToTasksResult,
} from "./use-estimate-to-tasks-conversion";
export { useEstimateToTasksConversion } from "./use-estimate-to-tasks-conversion";

// Estimates
export type {
  Estimate,
  UseEstimatesParams,
  EstimatesResponse,
} from "./use-estimates";
export {
  useEstimates,
  useEstimatesSimple,
  useEstimatesOptimized,
  useEstimatesByClient,
  useEstimatesByProject,
  useEstimatesMetrics,
} from "./use-estimates";

// Pipeline Estimates
export type {
  PipelineOpportunity,
  UsePipelineEstimatesParams,
} from "./use-pipeline-estimates";
export {
  usePipelineEstimates,
  usePipelineEstimatesByStage,
  usePipelineEstimatesByClient,
} from "./use-pipeline-estimates";

// Proposals
export type {
  UseProposalsParams,
  CreateProposalInput,
  UpdateProposalInput,
  ProposalMetricsSummary,
} from "./use-proposals";
export {
  useProposals,
  useCreateProposal,
  useUpdateProposal,
  useDeleteProposal,
  useProposalsMetrics,
} from "./use-proposals";
